<template>
  <div id="section1">
    <div
      class="fondoGris"
      style="padding: 0 !important; "
    >
      <div class="wrapper">
        <carousel
          :autoplay="true"
          :autoplay-timeout="3000"
          :autoplay-hover-pause="true"
          :loop="true"
          :per-page="1"
          :pagination-enabled="false"
          class=""
        >
          <slide
            v-for="(item, idx) in p8s1items"
            :key="idx"
          >
            <div class="p8s1sliderIMG">
              <b-img :src="p8s1itemsI[idx].p8s1img" />
            </div>
            <b-container fluid>
              <b-container>
                <div class="HeadContainer">
                  <div class="HeadVertical-center p8s1sliderFoo">
                    <h3>{{ item.p8s1title }}</h3>
                  </div>
                </div>
              </b-container>
            </b-container>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en":{
    "p8s1items": [
      {
        "p8s1title":
          "Offers of university internships in companies and hotels in Germany"
      },
      {
        "p8s1title":
          "Offers of university internships in companies and hotels in Spain"
      },
      {
        "p8s1title":
          "Offers of university internships in companies and hotels in France"
      },
      {
        "p8s1title":
          "Offers of university internships in companies and hotels in Mexico"
      }
    ]
  },
  "es":{
    "p8s1items": [
      {
        "p8s1title":
          "Ofertas de prácticas universitarias en empresas y hoteles en Alemania"
      },
      {
        "p8s1title":
          "Ofertas de prácticas universitarias en empresas y hoteles en España"
      },
      {
        "p8s1title":
          "Ofertas de prácticas universitarias en empresas y hoteles en Francia "
      },
      {
        "p8s1title":
          "Ofertas de prácticas universitarias en empresas y hoteles en México"
      }
    ]
  }
}
</i18n>

<script>
export default {
    data() {
        return {
            slide: 0,
            sliding: null,
            p8s1itemsI: [
                {
                    p8s1img: require("@/assets/images/banners/page8/alemania.jpg")
                },
                {
                    p8s1img: require("@/assets/images/banners/page8/spain.jpg")
                },
                {
                    p8s1img: require("@/assets/images/banners/page8/francia.jpg")
                },
                {
                    p8s1img: require("@/assets/images/banners/page8/mexico.jpg")
                }
            ]
        };
    },
    computed: {
        p8s1items() {
            return this.$t("p8s1items");
        }
    }
};
</script>

<style lang="scss">
.fondoGris img{
  margin: 0 !important;
}

.p8s1sliderIMG {
	top: 0;
	left: 0;
  position: relative;

  img{
    top: 0;
    left: 0;
    width: 100%;
    height: 500px;
    object-fit: cover;
    object-position: center;
  }
}

.p8s1sliderFoo {
  h3 {
    font-size: 2em !important;
    padding: 0.5em !important;
    background-color: rgba($color: #ffffff, $alpha: 0.7);
    color: black;
    border-radius: 1em; 
    width: 100%;
    @media (max-width: 768px) {
      font-size: 1.5em !important;
    }
    @media (max-width: 425px) {
      font-size: 1.1em !important;
    }
  }
}

</style>
